import { ProjectIntegrationType } from 'types'

type TaskSourceDetails = ShotgridTaskSourceDetails | JiraTaskSourceDetails | ClickupTaskSourceDetails

export const isShotgridTaskSourceDetails = (
  sourceDetails: TaskSourceDetails,
): sourceDetails is ShotgridTaskSourceDetails => {
  return sourceDetails.type === ProjectIntegrationType.ShotGrid
}

export const isJiraTaskSourceDetails = (
  sourceDetails: TaskSourceDetails,
): sourceDetails is JiraTaskSourceDetails => {
  return sourceDetails.type === ProjectIntegrationType.Jira
}

export const isClickupTaskSourceDetails = (
  sourceDetails: TaskSourceDetails,
): sourceDetails is ClickupTaskSourceDetails => {
  return sourceDetails.type === ProjectIntegrationType.Clickup
}
